import { createCommand } from 'lexical'

import { INSERT_EMOJI_PAYLOAD } from './interface'

export const INSERT_EMOJI_COMMAND = createCommand<INSERT_EMOJI_PAYLOAD>(
  'INSERT_EMOJI_COMMAND'
)
